import React from "react";
import { useTranslation } from "react-i18next";
import "./postBookingPages.css";

function SummaryPage() {
  const { t } = useTranslation();

  return (
    <div className="main-container">
      <h2>{t("bookingSummary.processingMessage")}</h2>
    </div>
  );
}

export default SummaryPage;